module.exports = "//static.hsappstatic.net/marketplace-ui-common/static-1.4628/img/callout-wave.svg"